import styled from 'styled-components';

import { colors } from 'Style/colors';

export const ExcelUploadContainer = styled.div`
  width:100%;
  height:100%;
`;
